export const tec_aux_saude_bucal = {
  nome: 'Téc. Aux de Saúde Bucal',
  id_perfil: 14,
  dashboard: [
    {
      link: '',
      titulo: 'Pódio e equipes por classificação',
      icone: false,
      imagem: '',
      svg: '',
      key: 'modal_ranking_indicadores_aps',
      type: 'modal',
    },
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'VinculoAcompanhamento',
      key: 'vinculo_acompanhamento',
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
      featured: true,
    },
  ],
  administracao: [],
  gestao_cadastros: [],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [
    {
      link: '/saude-bucal',
      titulo: 'eSB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal',
    },
  ],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  indicadores_esb: [
    {
      link: '/indicadores-esb/estrategicos',
      titulo: 'Estratégicos',
      icone: false,
      imagem: '',
      svg: 'Estrategicos',
      key: 'indicadores_esb_estrategicos',
    },
    {
      link: '/indicadores-esb/ampliados',
      titulo: 'Ampliados',
      icone: false,
      imagem: '',
      svg: 'Ampliados',
      key: 'indicadores_esb_ampliados',
    },
  ],
  indicadores_esb_estrategicos: [
    {
      link: '/indicadores-esb/estrategicos/gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'Gestantes',
      key: 'estrategicos_gestantes',
    },
    {
      link: '/indicadores-esb/estrategicos/criancas',
      titulo: 'Crianças',
      icone: false,
      imagem: '',
      svg: 'Criancas',
      key: 'estrategicos_criancas',
    },
    {
      link: '/indicadores-esb/estrategicos/atendimentos-na-esb',
      titulo: 'Atendimentos na eSB',
      icone: false,
      imagem: '',
      svg: 'AtendimentosNaEsb',
      key: 'atendimentos_na_esb',
    },
  ],
  indicadores_esb_ampliados: [
    {
      link: '/indicadores-esb/ampliados/prevencao',
      titulo: 'Prevenção',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'prevencao',
    },
    {
      link: '/indicadores-esb/ampliados/atendimentos-domiciliares',
      titulo: 'Atendimentos domiciliares',
      icone: false,
      imagem: '',
      svg: 'AtendimentosDomiciliares',
      key: 'ampliados_atendimentos_domiciliares',
    },
    {
      link: '/indicadores-esb/ampliados/agendamentos-72h',
      titulo: 'Agendamentos 72h',
      icone: false,
      imagem: '',
      svg: 'Agendamentos72h',
      key: 'agendamentos_72h',
    },
    {
      link: '/indicadores-esb/ampliados/satisfacao-do-cidadao',
      titulo: 'Satisfação do cidadão',
      icone: false,
      imagem: '',
      svg: 'SatisfacaoDoCidadao',
      key: 'satisfacao_do_cidadao',
    },
  ],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Resultado Municipal',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/profissional',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento/profissional',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/avaliacao-atendimentos',
      titulo: 'Avaliação do atendimento',
      icone: 'icofont-heart-eyes',
      key: 'avaliacao_atendimentos',
    },
    {
      link: '/agenda-por-profissional/profissional',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
  ],
  bpa_e_ras: [],
  saude_bucal: [
    {
      link: '/primeira-consulta-programada',
      titulo: 'Primeira consulta',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/procedimentos-odonto-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-atramautico',
      titulo: 'Tratamento Atraumático',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/saude-bucal-gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'ConsultasPreNatal',
      key: 'saude_bucal_gestantes',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
  ],
  esf_eap: [],
  emulti: [],
}
